import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from "react";
export const defaultPopperContext = {
    activePopperId: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setActivePopperId: () => { },
};
const PopperContext = createContext(defaultPopperContext);
export const PopperProvider = ({ children }) => {
    const [activePopperIdState, setActivePopperIdState] = useState(null);
    const setActivePopperId = (id) => {
        setActivePopperIdState(id);
    };
    const contextValue = useMemo(() => ({
        activePopperId: activePopperIdState,
        setActivePopperId,
    }), [activePopperIdState]);
    return _jsx(PopperContext.Provider, { value: contextValue, children: children });
};
export const usePopper = () => {
    const context = useContext(PopperContext);
    return context;
};
//# sourceMappingURL=PopperProvider.js.map